export const ORGANIZATION_SETTINGS_RESET_STATE = 'ORGANIZATION_SETTINGS_RESET_STATE';
export const ORGANIZATION_SETTINGS_CURRENT_ITEM = 'ORGANIZATION_SETTINGS_CURRENT_ITEM';

export const ORGANIZATION_SETTINGS_REQUEST_LOADING = 'ORGANIZATION_SETTINGS_REQUEST_LOADING';
export const ORGANIZATION_SETTINGS_REQUEST_SUCCESS = 'ORGANIZATION_SETTINGS_REQUEST_SUCCESS';
export const ORGANIZATION_SETTINGS_REQUEST_FAILED = 'ORGANIZATION_SETTINGS_REQUEST_FAILED';

export const ORGANIZATION_SETTINGS_CURRENT_ACTION = 'ORGANIZATION_SETTINGS_CURRENT_ACTION';
export const ORGANIZATION_SETTINGS_RESET_ACTION = 'ORGANIZATION_SETTINGS_RESET_ACTION';